import { render, staticRenderFns } from "./OsSummary.vue?vue&type=template&id=172eead6"
import script from "./OsSummary.vue?vue&type=script&lang=js"
export * from "./OsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports